import './detection.less'
import { KeyValueDetection } from './keyValueDetection'
import WidgetCard from '../../../../../../components/WidgetCard'
import { DetectionIcon } from '../../../../../attributes/settings/components/common/icon'
import { Typography } from '@lightbeamai/design-system'
import React from 'react'
import { useIntl } from 'react-intl'

export const Detection = () => {
  const intl = useIntl()

  return (
    <WidgetCard
      widgetTitle={{
        title: intl.formatMessage({
          id: 'attributeManagementSettings.customAttributes.detection'
        }),
        icon: <DetectionIcon />,
        bordered: true
      }}
      className="xs-pb-24 custom-attributes-detection"
    >
      <Typography variant="base" type="strong" className="xs-mb-24">
        {intl.formatMessage({
          id: 'attributeManagementSettings.customAttributes.detection.description'
        })}
      </Typography>

      <div className="xs-mt-20">
        <KeyValueDetection />
      </div>
    </WidgetCard>
  )
}
